<template>
    <div>
      <h2>Eliminar Genética</h2>
      <p>¿Estás seguro de que deseas eliminar la genética <strong>{{ genetica.nombre }}</strong>?</p>
      <div class="d-flex justify-content-end">
        <button @click="eliminarGenetica" class="btn btn-danger me-2">Eliminar</button>
        <button @click="$emit('accionTerminada')" class="btn btn-secondary">Cancelar</button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/axios";
  
  export default {
    props: {
      genetica: {
        type: Object,
        required: true,
      },
    },
    methods: {
      async eliminarGenetica() {
        try {
          await axios.delete(`/api/eliminarGenetica/${this.genetica.id}`);
          alert("Genética eliminada con éxito");
          this.$emit("accionTerminada");
        } catch (error) {
          console.error("Error al eliminar la genética:", error);
        }
      },
    },
  };
  </script>
  